import { INFO_BOX } from 'store/infoItems';
import { PATIENT_REPORTS } from 'store/patients';

export const highlightMap = {
  infoBoxTab: `#${INFO_BOX}`,
  patientReportsTab: `#${PATIENT_REPORTS}`,
};
